import { findHelpText, formatAmount } from "../transformCoverage";
import type { CoverLimitProps } from "../../CoverLimit";
import { isCurrency, titleCase } from "../../../../../utils/text";
import type { HelpText, SpecificExcesses } from "../../../types";

export const formatExcesses = (
  displayExcess: string,
  specificExcesses: SpecificExcesses[] = [],
  helpText: HelpText[] = [],
): CoverLimitProps[] => {
  const otherClaimsWording = specificExcesses.length
    ? "All other Claims"
    : "All Claims";
  const otherClaimsValue =
    displayExcess + (isCurrency(displayExcess) ? " excess" : "");

  const allExcesses = [
    ...specificExcesses,
    { excessName: otherClaimsWording, excessValue: otherClaimsValue },
  ];

  return allExcesses.map(({ excessName, excessValue }) => {
    return {
      title: titleCase(excessName),
      amount: formatAmount(excessValue),
      explainer: findHelpText(helpText, excessName),
    };
  });
};
